// import config from './../config';
// const env = 'development';

angular.module('Constants', [])
// provided by the .env loaded by webpack
.constant('DRUPAL_API_URL', process.env.DRUPAL_API_URL)
.constant('ASSET_SHOP_API_URL', process.env.ASSET_SHOP_API_URL)
.constant('SMX_API_URL', process.env.SMX_API_URL)
.constant('ANALYTICS_URL', process.env.ANALYTICS_URL)
.constant('SMX_GATEWAY_URL', process.env.SMX_GATEWAY_URL)
.constant('IDS_URL', process.env.IDS_URL)
.constant('ANALYTICS_API_URL', process.env.ANALYTICS_API_URL);
